import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { api, formatApiError } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Leaf, EnvelopeSimple } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { identifier, reset_base: window.location.origin });
      setMsg(data.message);
      setSent(true);
    } catch (err) {
      setMsg(formatApiError(err.response?.data?.detail) || err.message);
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F0FDF4]">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-emerald-100 p-8">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <img src="/logo.png" className="h-10 w-10 rounded-lg object-contain" alt="logo" />
          <span className="font-display font-extrabold text-emerald-900 text-lg">{t("brand")}</span>
        </Link>
        {sent ? (
          <div className="text-center py-4" data-testid="forgot-sent">
            <div className="h-14 w-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <EnvelopeSimple size={28} weight="duotone" className="text-emerald-700" />
            </div>
            <p className="text-emerald-900 font-semibold mb-2">{t("forgot_password")}</p>
            <p className="text-slate-500 text-sm">{msg}</p>
            <Link to="/login" data-testid="back-to-login" className="inline-block mt-6 text-emerald-700 font-semibold hover:underline">{t("login")}</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <div className="flex items-center gap-2 mb-2">
              <Leaf size={22} weight="fill" className="text-emerald-600" />
              <h1 className="font-display text-2xl font-bold text-emerald-900">{t("forgot_password")}</h1>
            </div>
            <p className="text-slate-500 text-sm mb-6">{t("forgot_sub")}</p>
            <Label className="text-emerald-900 font-semibold">{t("email")}</Label>
            <Input data-testid="forgot-identifier-input" className="mt-1.5 h-11" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required />
            <Button data-testid="forgot-submit-btn" disabled={loading} className="w-full mt-6 h-11 bg-emerald-800 hover:bg-emerald-900">
              {loading ? t("loading") : t("send_reset_link")}
            </Button>
            <p className="text-center text-sm text-slate-500 mt-6">
              <Link to="/login" className="text-emerald-700 font-semibold hover:underline">{t("login")}</Link>
            </p>
          </form>
        )}
      </motion.div>
    </div>
  );
}
